import React from 'react'
import './LeftSideNav.css'
import { Link, useLocation } from 'react-router-dom'
const LeftSideNav = () => {

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  return <div className="leftsidenav-container">
    <div className="item">
      <Link className={splitLocation[2] === "my-profile" ? "active-link" : ""} to="/auth/my-profile">Account Management Home</Link>
    </div>
    <hr className="divider" />
    <div className="item">
      <Link className={splitLocation[2] === "change-password" ? "active-link" : ""} to="/auth/change-password">Change Password</Link>


    </div>
    <hr className="divider" />
    <div className="item">
      <a href={`${window.location.origin}/accountmanagementmfa/oauth2/authorization/oracle`}>Two-step Verification</a>
    </div>
    <hr className="divider" />
    <div className="item">
      <Link className={splitLocation[2] === "security-question" ? "active-link" : ""} to="/auth/security-question">Security Questions</Link>
    </div>


    {/* Nice to have features, will implement later after all the previous screens are done */}
    {/* <hr className="divider" />
    <div className="item">Sign In History</div>
    <hr className="divider" />
    <div className="item">Application Access</div>*/}

    <hr className="divider" />
    <div className="item">
    <Link className={splitLocation[2] === "faqs" ? "active-link" : ""} to="/auth/faqsauth">FAQs</Link>
    </div>
  </div>
}

export default LeftSideNav